import { render, staticRenderFns } from "./veHqCangkuEdit.vue?vue&type=template&id=28b8251a&scoped=true"
import script from "./veHqCangkuEdit.vue?vue&type=script&lang=js"
export * from "./veHqCangkuEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8251a",
  null
  
)

export default component.exports